export const shiftsCoverageSelector = state => state.shiftsCoverage;
